import { Concurrent_Work_Confirmation } from "../components/Concurrent_Work_Confirmation";
import { useTranslation } from "react-i18next";
import {
    AlertContext,
    LangContext,
    MenuContext,
    Page,
    Theme,
    ThemeContext,
    ThemeDark,
    ThemeLight
} from 'monica-alexandria';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Routes, Route, Navigate, useLocation, useParams } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { useSelector } from 'react-redux';
import Navbar_ from '../components/navbar/Navbar_';
import PANEL from '../admin/views/panel/PANEL';
import NEW_OFFER from '../admin/views/newOffer/NEW_OFFER';
import OFFER_EDITOR from '../admin/views/offerEditor/OFFER_EDITOR';
import OFFER_LIST from '../admin/views/offerList/OFFER_LIST';
import OFFER_PUBLIC from '../admin/views/offerPublic/OFFER_PUBLIC';
import OFFER_PREVIEW from '../admin/views/offerPreview/OFFER_PREVIEW';
import AGENCY from '../admin/views/agency/AGENCY';
import LEGACY_OFFERS from '../admin/views/legacyOffers/LEGACY_OFFERS';
import SASS from '../admin/views/sass/SASS';
import GOALS from '../admin/views/goals/GOALS';
import NO_ACCESS from '../admin/views/noAccess/NO_ACCESS';
import { init } from '../helpers/initMenuOptions';
import { get_route_language } from '../helpers/routeLanguage';
import { GuardedRoute } from '../services/authentication/Guard';
import { Protector } from '../services/authentication/Protector';
import { HrAccessProvider } from '../services/authentication/HrAccess';
import config from '../config';

const DoloresApplicationsRedirect = () => {
    const { lang } = useParams();
    const routeLanguage = get_route_language(lang || 'en');

    useEffect(() => {
        window.location.assign(`${config.hr}/${routeLanguage}/akihiko/dolores/applications`);
    }, [routeLanguage]);

    return <></>;
};

export default function Router() {
    const { t } = useTranslation();
    const user = useSelector((state) => state.user.user);
    const location = useLocation();

    const [theme, setTheme] = useState();
    const [language, setLanguage] = useState();
    const [activeMenu, setActiveMenu] = useState('Main');
    const [alerts, setAlerts] = useState([]);

    useEffect(() => {
        init(user, setTheme, setLanguage);
    }, [user]);

    if (!theme || !language) {
        return <></>;
    }

    const routeLanguage = get_route_language(language);
    const isPublicOfferPreviewRoute = /^\/[^/]+\/(offer\/[^/]+|offers\/v3\/[^/]+\/public)\/?$/.test(location.pathname || '');
    const offerV3Enabled = config.offerV3Enabled;
    const hideNavbarForPreview = isPublicOfferPreviewRoute;

    return (
        <LangContext.Provider value={{ language, setLanguage }}>
            <ThemeContext.Provider value={{ theme, setTheme }}>
                <ThemeProvider theme={theme === 'dark' ? ThemeDark : ThemeLight}>
                    <AlertContext.Provider value={{ alerts, setAlerts }}>
                        <Theme>

                            <Page>
                                <HrAccessProvider>
                                    <MenuContext.Provider value={{ activeMenu, setActiveMenu }}>
                                            <Helmet>
                                                <title>Doitforme | Offers</title>
                                            </Helmet>
                                            {!hideNavbarForPreview ? (
                                                <GuardedRoute>
                                                    <Navbar_ />
                                                </GuardedRoute>
                                            ) : null}
                                            <Routes>
                                                <Route path="/" element={<Navigate to={`/${routeLanguage}`} />} />

                                                <Route path="/:lang" element={<Protector role="Scout">{offerV3Enabled ? <OFFER_LIST /> : <PANEL offerFormat="new" />}</Protector>} />
                                                <Route path="/:lang/offers" element={<Protector role="Scout"><OFFER_LIST /></Protector>} />
                                                <Route path="/:lang/offers/v3/:id" element={<Protector role="Scout"><OFFER_EDITOR /></Protector>} />
                                                <Route path="/:lang/offers/v3/:id/public" element={<OFFER_PUBLIC />} />
                                                <Route path="/:lang/akihiko/dolores" element={<Protector role="Scout">{offerV3Enabled ? <OFFER_LIST /> : <PANEL offerFormat="new" /> }</Protector>} />
                                                <Route path="/:lang/akihiko/dolores/applications" element={<Protector role="Baron"><DoloresApplicationsRedirect /></Protector>} />
                                                <Route path="/:lang/sales" element={<Protector role="Baron">{offerV3Enabled ? <OFFER_LIST /> : <PANEL offerFormat="new" /> }</Protector>} />
                                                <Route path="/:lang/marketing" element={<Protector role="Baron">{offerV3Enabled ? <OFFER_LIST /> : <PANEL offerFormat="new" /> }</Protector>} />
                                                <Route path="/:lang/website" element={<Protector role="Baron">{offerV3Enabled ? <OFFER_LIST /> : <PANEL offerFormat="new" /> }</Protector>} />
                                                <Route path="/:lang/creative" element={<Protector role="Baron">{offerV3Enabled ? <OFFER_LIST /> : <PANEL offerFormat="new" /> }</Protector>} />
                                                <Route path="/:lang/new-offer" element={<Protector role="Scout">{offerV3Enabled ? <OFFER_EDITOR /> : <NEW_OFFER />}</Protector>} />
                                                <Route path="/:lang/agency" element={<Protector role="Scout">{offerV3Enabled ? <OFFER_LIST /> : <AGENCY />}</Protector>} />
                                                <Route path="/:lang/legacy-offers" element={<Protector role="Scout">{offerV3Enabled ? <OFFER_LIST /> : <LEGACY_OFFERS />}</Protector>} />
                                                <Route path="/:lang/sass" element={<Protector role="Doer"><SASS /></Protector>} />
                                                <Route path="/:lang/goals" element={<Protector role="Baron"><GOALS /></Protector>} />
                                                
                                                {/* <Route path="/:lang" element={<Protector role="Doer"><PANEL /></Protector>} />
                                                <Route path="/:lang/sales" element={<Protector role="Doer"><PANEL /></Protector>} />
                                                <Route path="/:lang/marketing" element={<Protector role="Doer"><PANEL /></Protector>} />
                                                <Route path="/:lang/website" element={<Protector role="Doer"><PANEL /></Protector>} />
                                                <Route path="/:lang/creative" element={<Protector role="Doer"><PANEL /></Protector>} />
                                                <Route path="/:lang/new-offer" element={<Protector role="Doer"><NEW_OFFER /></Protector>} />
                                                <Route path="/:lang/agency" element={<Protector role="Doer"><AGENCY /></Protector>} />
                                                <Route path="/:lang/legacy-offers" element={<Protector role="Doer"><LEGACY_OFFERS /></Protector>} />
                                                <Route path="/:lang/sass" element={<Protector role="Doer"><SASS /></Protector>} /> */}

                                                <Route path="/:lang/offer/:offerId" element={<OFFER_PREVIEW />} />
                                                <Route path="/:lang/auth" element={<NO_ACCESS />} />
                                                <Route path="/:lang/login" element={<NO_ACCESS />} />
                                                <Route path="/:lang/access-denied" element={<NO_ACCESS />} />
                                            </Routes>
                                    </MenuContext.Provider>
                                </HrAccessProvider>
                            </Page>
                                <Concurrent_Work_Confirmation
                                  message={t("This assignee already has active work. Start another item at the same time?")}
                                  confirmationPrompt={t("Type Yes to confirm")}
                                  yes={t("Yes")}
                                  no={t("No")}
                                />
                        </Theme>
                    </AlertContext.Provider>
                </ThemeProvider>
            </ThemeContext.Provider>
        </LangContext.Provider>
    );
}
